import { render, staticRenderFns } from "./privacy_policy_link.vue?vue&type=template&id=6a0ed0d5&"
import script from "./privacy_policy_link.vue?vue&type=script&lang=js&"
export * from "./privacy_policy_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a0ed0d5')) {
      api.createRecord('6a0ed0d5', component.options)
    } else {
      api.reload('6a0ed0d5', component.options)
    }
    module.hot.accept("./privacy_policy_link.vue?vue&type=template&id=6a0ed0d5&", function () {
      api.rerender('6a0ed0d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/administration/privacy_policy_link.vue"
export default component.exports